import { useEffect, useState } from 'react';
import { makeRequest } from '@/services/makeRequest';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
	getCountrySlug,
	getUserCurrentCity,
	getUserCurrentDistrict,
	getUserRegion,
} from '../../../stores/slices/userSlice';
import { ButtonLink } from '../../ui';
import { Helmet } from 'react-helmet';
import useLadyService from '@/services/LadyService';
import { getSelections } from '../../../stores/slices/modelsState';
import { getFilterState } from '@/stores/slices/filterSlice';
import { useFilterLogicContext } from '@/components/filter/FilterLogicProvider';

const Selection = ({ isPage = true }) => {
	const { t, navigate, lang, scrollToTop } = useLadyService();

	const FILTER = useFilterLogicContext();
	const filterState = useSelector(getFilterState);

	const currentCity = useSelector(getUserCurrentCity);
	const defaultSelections = useSelector(getSelections);
	const [data, setData] = useState(defaultSelections);
	const region = useSelector(getUserRegion);
	const { city } = useParams();
	const citySlug = city?.split('_')[0];
	const currentDistrict = useSelector(getUserCurrentDistrict);
	const districtSlug = city?.split('_')[1];

	const fetchData = async () => {
		try {
			const route = `selections/${citySlug}`;
			const method = 'GET';
			const payload = {
				...(!!currentDistrict.id ||
				(districtSlug && districtSlug !== '')
					? {
							district: currentDistrict?.id
								? currentDistrict?.id
								: districtSlug,
						}
					: null),
			};

			const result = await makeRequest({ route, method, payload });
			if (!result) {
				navigate('/404');
			}

			if (result) {
				setData(result);
			}
		} catch (error) {}
	};

	const fetchDisabled = async () => {
		// FILTER.handleApplyFilter(filterState);
	};

	useEffect(() => {
		if (isPage) fetchDisabled();
		if (city) fetchData();
	}, [city]);

	useEffect(() => {
		if (isPage) scrollToTop();
	}, []);

	const countrySlug = useSelector(getCountrySlug);
	let title = t('selectiontitle', {
		City:
			currentCity.title +
				(currentDistrict?.id ? ` ${currentDistrict?.name}` : '') ?? '',
		Country: `, ${region}`,
	});
	let h1 = t('selectionmodels', {
		City:
			currentCity.title +
				(currentDistrict?.id ? ` ${currentDistrict?.name}` : '') ?? '',
		Country: `, ${region}`,
	});
	if (countrySlug) {
		title =
			t('selectiontitle', { City: '', Country: '' }) +
			' ' +
			currentCity?.title +
			(currentDistrict?.id ? ` ${currentDistrict?.name}` : '');
		h1 =
			t('selectionmodels', { City: '', Country: '' }) +
			' ' +
			currentCity?.title +
			(currentDistrict?.id ? ` ${currentDistrict?.name}` : '');
	}
	useEffect(() => {
		if (isPage) {
			document.title = title;
		}
	}, [isPage, title]);
	return (
		<>
			{isPage ? (
				<Helmet>
					<meta
						name="description"
						content={t('selectdesc', {
							City: currentCity.title ?? '',
							Country: region,
						})}
					/>
				</Helmet>
			) : null}
			<main>
				<section className="navigation__container">
					{isPage ? <h1>{h1}</h1> : <h2>{h1}</h2>}
					<div className="d-flex gap-12 flex-wrap flex-fit-content">
						{!!data?.length &&
							data.map((item) => {
								const segments = item.split('/');
								const lastSegment =
									segments[segments.length - 1];
								const title = lastSegment
									.split('-')
									.map((str) => {
										switch (str) {
											case 'elitelady':
												return 'elite';
											case 'vchat':
												return 'videochat';
											case 'ero':
												return 'erocontent';
											case 'booking':
												return 'onlineorder';
											case 'anal':
												return 'anal-sex';
											case 'asian':
												return 'asiatag';
											default:
												return str;
										}
									})
									.map((result) => t(result));

								return (
									<ButtonLink
										key={lastSegment}
										href={`/${lang}/${city}/${lastSegment}`}
										title={title.join(', ')}
										size={'xs'}
										clazz={
											'button_outline--black _no-underline'
										}
										onClick={() => {
											window.scrollTo(0, 0);
										}}
									>
										{title.join(', ')}
									</ButtonLink>
								);
							})}
					</div>
				</section>
			</main>
		</>
	);
};
export default Selection;
